/** Import File Dto. */
export class ImportFile {
  constructor(data) {
    this.file = data.file;
    this.groupAdminId = data.groupAdminId;
  }
}
